import Client from '@/clients/apiClient';
import { stringify } from 'query-string';

const resource = 'business-banks';

export default {
  get(payload) {
    const params = Object.assign(
      {
        page: payload.page,
        limit: payload.limit || 10,
        business_id: payload.businessId ? payload.businessId : null,
      },
      payload.filter
    );
    return Client.get(`${resource}?${stringify(params)}`);
  },
  create(payload) {
    return Client.post(`${resource}`, payload);
  },
  update(id, payload) {
    return Client.put(`${resource}/${id}`, payload);
  },
  delete(id) {
    return Client.delete(`${resource}/${id}`);
  },
};
